import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Calendar } from "react-bootstrap-icons";
import PropTypes from "prop-types";
import DatePickerModal from "./DatePickerModal";
import "./ControlBar.css";

// Helper function for week display formatting
const formatWeekDisplay = (date) => {
  const d = new Date(date);
  const monthShort = d.toLocaleDateString("en-US", { month: "short" });
  const day = d.getDate();
  return `${monthShort} ${day}`;
};

const ControlBar = ({
  selectedPeriod,
  onPeriodChange,
  selectedDate,
  onDateChange,
  completedOnly,
  onCompletedOnlyChange,
}) => {
  const [showDatePicker, setShowDatePicker] = useState(false);

  const getDisplayValue = () => {
    if (!selectedDate) {
      return "Select Date";
    }
    return selectedDate.shortDisplay || selectedDate.display || selectedDate;
  };

  return (
    <div className="control-bar">
      <div className="control-bar-left">
        <Form.Select
          value={selectedPeriod}
          onChange={(e) => onPeriodChange(e.target.value)}
          className="period-select"
        >
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
          <option value="quarterly">Quarterly</option>
          <option value="yearly">Yearly</option>
        </Form.Select>

        {selectedPeriod === "weekly" ? (
          <div className="date-picker-container">
            <Form.Control
              type="date"
              value={selectedDate?.date || ""}
              onChange={(e) => {
                const dateValue = e.target.value;
                if (dateValue) {
                  const date = new Date(dateValue);
                  onDateChange({
                    date: dateValue,
                    display: formatWeekDisplay(date),
                    shortDisplay: formatWeekDisplay(date),
                  });
                }
              }}
              className="date-input"
              style={{
                WebkitAppearance: "textfield",
                MozAppearance: "textfield",
              }}
            />
          </div>
        ) : (
          <div
            className="date-picker-container"
            onClick={() => setShowDatePicker(true)}
            style={{ cursor: "pointer" }}
          >
            <Form.Control
              type="text"
              value={getDisplayValue()}
              readOnly
              className="date-input"
              style={{ cursor: "pointer" }}
            />
            <div className="date-icon">
              <Calendar size={14} color="#000000" />
            </div>
          </div>
        )}
      </div>

      <div className="control-bar-right">
        <Form.Check
          type="checkbox"
          id="completed-only-checkbox"
          checked={completedOnly}
          onChange={(e) => onCompletedOnlyChange(e.target.checked)}
          label="Completed Only"
          className="completed-only-checkbox"
        />
      </div>

      <DatePickerModal
        show={showDatePicker}
        onHide={() => setShowDatePicker(false)}
        period={selectedPeriod}
        currentValue={selectedDate}
        onSelect={(value) => {
          onDateChange(value);
          setShowDatePicker(false);
        }}
      />
    </div>
  );
};

ControlBar.propTypes = {
  selectedPeriod: PropTypes.string.isRequired,
  onPeriodChange: PropTypes.func.isRequired,
  selectedDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onDateChange: PropTypes.func.isRequired,
  completedOnly: PropTypes.bool.isRequired,
  onCompletedOnlyChange: PropTypes.func.isRequired,
};

export default ControlBar;
